import AuthButton from './AuthButton';

export default AuthButton;
